export default __webpack_public_path__ + "7fcca7a5526688633f3514adfe5eefca.svg";